globalThis["__INTERFERE_RELEASE_SLUG__"] = "rel_b26eb41b0fd3d205";
globalThis["__INTERFERE_PROXY_MODE__"] = true;
globalThis["__INTERFERE_PUBLIC_KEY__"] = "interfere_pub_us_c417acf4fa40483387ab126273e735c1";
import { init } from "@interfere/next/instrument-client";

init();